// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"151":"a99fa8d3","890":"a99fa8d3"}[chunkId] + ".css";
};